import Sponsorship from '../models/sponsorship'
import ApiBase from '@/api/apiBase'

class ApiSponsorships {

    static objectToFormData( obj, form, namespace ) {
    
        var fd = form || new FormData();
        var formKey;
        
        for ( const property in obj ) {

          if ( obj.hasOwnProperty( property ) ) {
            
            formKey = namespace
                ? namespace + '[' + property + ']'
                : property;
           
            // if the property is an object, but not a File,
            // use recursivity.
            if ( Array.isArray( obj[ property ] ) && !(obj[property] instanceof File )) {
                
                obj[ property ].forEach( ( item, i ) => {

                    if ( !Array.isArray( item ) ) {
                        
                        const key = `${formKey}[${ i }]`;
                        this.objectToFormData( item, fd, key );
                    }
                });
            } else {
              
                // if it's a string or a File object
                if ( obj[ property ] !== null && obj[ property ] !== undefined && obj[ property ] !== '' ) {

                    fd.append( formKey, obj[property] );
                }
            }
            
          }
        }
        
        return fd;
          
    };

    static parseAll( response ) {

        const result = []

        for( const i in response.data.data ){

            result.push( Sponsorship.parse( response.data.data[i] ) )
        }
        
        return result
    }

    static parseOne( response ) {

        return Sponsorship.parse( response.data.data );
    }

    static all( callback, errorCallback ) {

        ApiBase.get( '/sponsorships', callback, ApiSponsorships.parseAll, errorCallback );
    }

    static get( id, callback, errorCallback ) {

        ApiBase.get( `/sponsorships/${ id }`, callback, ApiSponsorships.parseOne, errorCallback );
    }

    static create( sponsorship, callback, errorCallback ) {

        const formData = this.objectToFormData( sponsorship );
        ApiBase.post( '/sponsorships', formData, callback, ApiBase.noParse, errorCallback );
    }

    static delete( id, callback, errorCallback ) {

        ApiBase.delete( `/sponsorships/${ id }`, callback, ApiBase.noParse, errorCallback );
    }

    static updateSponsorship( { id, data }, callback, errorCallback ) {
        data['_method'] = 'PUT';
        const formData = this.objectToFormData( data );
        ApiBase.post( `/sponsorships/${ id }`, formData, callback, ApiBase.noParse, errorCallback );
    }

    static createSection( data, callback, errorCallback ) {

        ApiBase.post( `/sections-sponsorships`, data, callback, ApiBase.noParse, errorCallback );
    }

    static updateSection( data, callback, errorCallback ) {

        const id = data.id;
        delete data.id;
        ApiBase.put( `/sections-sponsorships/${ id }`, data, callback, ApiBase.noParse, errorCallback );
    }

    static addSectionContent( data, callback, errorCallback ) {

        const formData = this.objectToFormData( data );
        ApiBase.post( `/content-sponsorships`, formData, callback, ApiBase.noParse, errorCallback );
    }

    static updateSectionContent( data, callback, errorCallback ) {

        const id = data.id;
        delete data.id;
        const formData = this.objectToFormData( data );
        ApiBase.post( `/content-sponsorships/${ id }`, formData, callback, ApiBase.noParse, errorCallback );
    }

    static deleteSectionContent( id, callback, errorCallback ) {

        ApiBase.delete( `/content-sponsorships/${ id }`, callback, ApiBase.noParse, errorCallback );
    }

    static addEvidence( data, callback, errorCallback ) {

        ApiBase.post( `/evidence-sponsorships`, data, callback, ApiBase.noParse, errorCallback );
    }

    static updateEvidence( data, callback, errorCallback ) {
        
        const id = data.id;
        delete data.id;
        ApiBase.put( `/evidence-sponsorships/${ id }`, data, callback, ApiBase.noParse, errorCallback );
    }

    static deleteEvidence( id, callback, errorCallback ) {

        ApiBase.delete( `/evidence-sponsorships/${ id }`, callback, ApiBase.noParse, errorCallback );
    }

    static addOptionEvidence( data, callback, errorCallback ) {

        ApiBase.post( `/options-evidence`, data, callback, ApiBase.noParse, errorCallback );
    }

    static updateOptionEvidence( data, callback, errorCallback ) {
        const id = data.id;
        delete data.id;

        ApiBase.put( `/options-evidence/${ id }`, data, callback, ApiBase.noParse, errorCallback );
    }

    static deleteOptionEvidence( id, callback, errorCallback ) {
        ApiBase.delete( `/options-evidence/${ id }`, callback, ApiBase.noParse, errorCallback );
    }

}

export default ApiSponsorships;


// WEBPACK FOOTER //
// ./src/api/apiSponsorships.js